/**
 * requestId — a client-minted idempotency key for plan c's `(userId, requestId, position)`
 * uniqueness (`queue.server.ts`'s own header doc). `StageComponent.tsx`'s page verb minted this
 * inline first; `Wall.tsx`'s own `/continue` press (error-handling review F5) is the second caller,
 * which is the "copy until it graduates" rule's own trigger (root CLAUDE.md) — promoted here rather
 * than copied again.
 */
export function mintRequestId(): string {
    // `crypto.randomUUID` is absent outside a secure context; the fallback only has to be unique
    // per user, which the clock plus a random tail is.
    try {
        return crypto.randomUUID()
    } catch {
        return `${Date.now().toString(36)}-${Math.random().toString(36).slice(2, 12)}`
    }
}
